import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-aac83b74");

_pushScopeId("data-v-aac83b74");

var _hoisted_1 = {
  class: "toaster-wrap"
};

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withId(function () {
      return [_ctx.showT ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: ['toaster', _ctx.theme]
      }, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)], 2)) : _createCommentVNode("", true)];
    }),
    _: 3
  })]);
});